import React from "react";
import { daWO } from "./resultado";

// Marcador rápido con flechas arriba/abajo para cada lado.
// El marcador se deriva de la cantidad de goles (homeGoals/awayGoals).
// Si se pasa onGoleadores, se muestra un botón "Goleadores" debajo de cada equipo.
// Si se pasa onWO, se muestra además un botón "WO" que marca a ese equipo como el
// que dio el walk-over; `wo` ("home" | "away" | "both" | "") es el lado que ya lo
// dio. Los dos botones pueden quedar marcados a la vez (WO de los dos equipos).
export default function ScoreStepper({
  homeLabel,
  awayLabel,
  homeCount,
  awayCount,
  onAdd,
  onRemove,
  onGoleadores,
  onWO,
  wo,
  disabled,
}) {
  const side = (label, count, key) => (
    <div className="score-side">
      <div className="score-team">{label || "—"}</div>
      <button
        type="button"
        className="step-btn"
        onClick={() => onAdd(key)}
        disabled={disabled}
        aria-label={"Sumar gol " + (key === "home" ? "local" : "visitante")}
      >
        <svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true">
          <polygon points="12 5 21 19 3 19" fill="currentColor" />
        </svg>
      </button>
      <div className="score-value">{count}</div>
      <button
        type="button"
        className="step-btn"
        onClick={() => onRemove(key)}
        disabled={disabled || count === 0}
        aria-label={"Restar gol " + (key === "home" ? "local" : "visitante")}
      >
        <svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true">
          <polygon points="3 5 21 5 12 19" fill="currentColor" />
        </svg>
      </button>
      {onGoleadores && (
        <button
          type="button"
          className="btn btn-arhock btn-sm mt-2 mb-0"
          onClick={() => onGoleadores(key)}
          disabled={disabled}
        >
          Goleadores
        </button>
      )}
      {onWO && (
        <button
          type="button"
          className={"btn btn-arhock btn-sm mt-2 mb-0" + (daWO(wo, key) ? " wo-activo" : "")}
          onClick={() => onWO(key)}
          aria-pressed={daWO(wo, key)}
          title={"El equipo " + (key === "home" ? "local" : "visitante") + " da walk-over (pierde 3 a 0)"}
        >
          WO
        </button>
      )}
    </div>
  );

  return (
    <div className="score-stepper">
      {side(homeLabel, homeCount, "home")}
      <div className="score-vs">VS</div>
      {side(awayLabel, awayCount, "away")}
    </div>
  );
}
